import Layout from '../../internal/Layout.vue'
import IAagent from './KnowledgeTable.vue'

const IAagentRoutes = {
  component: Layout,
  children: [
    {
      name: 'IAagent',
      path: '/IAagent',
      component: IAagent,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ]
}

export default IAagentRoutes